import env from "$root/env";

/**
 * What the chat's execution panel says while a turn runs.
 *
 * The panel's own default is a flat "Working" (see `ExecutionTrigger`), and that is what this
 * deployment shows unless `featureFlags.sphereAI.playfulWorkingLabels` is on, in which case the
 * trigger rotates through {@link PLAYFUL_WORKING_LABELS} instead. `default.json` carries the flag
 * off, so an environment shows the plain label until it says otherwise.
 *
 * The vocabulary lives here rather than in the component library for the reason its day-separator
 * and message-time labels do: it is copy, and this desk's copy at that.
 */
const PLAYFUL_WORKING_LABELS = [
	"Money-moseying",
	"Yield-wrangling",
	"Alpha-hunting",
	"Beta-bopping",
	"Cashflowing",
	"Coin-counting",
	"Ledger-lollygagging",
	"Margin-marinating",
	"Asset-juggling",
	"Spread-squishing",
	"Coupon-clipping",
	"Capital-combobulating",
	"Portfolio-percolating",
	"Balance-sheet-brewing",
	"Dividend-doodling",
	"Treasury-tinkering",
	"Liquidity-sloshing",
	"Risk-wrangling",
	"Volatility-vibing",
	"Equity-embellishing",
	"Bond-befuddling",
	"Multiples-mulling",
	"EBITDA-ing",
	"Runway-ruminating",
	"P&L-puzzling",
	"Cash-crunching",
	"Numbers-noodling",
	"Decimal-dallying",
	"Basis-point-boogieing",
	"Mark-to-marketing",
] as const;

/**
 * The labels to hand the thread, or `undefined` to leave the panel on its own plain wording.
 *
 * Read at render rather than at module load, so a test — and a `window.env` swapped in by the
 * deploy's post-build step — sees the flag as it stands.
 */
export function sphereAIWorkingLabels(): readonly string[] | undefined {
	return env.featureFlags.sphereAI.playfulWorkingLabels ? PLAYFUL_WORKING_LABELS : undefined;
}
